import api from '@/libs/axios'

export default {
  getPermissions: () => api('/system/permissions'),
  createPermission: permission => api.post('/system/permissions', permission),
  updatePermission: permission => api.patch(`/system/permissions/${permission.id}`, permission),
}
